import React, {useEffect, 
               useState, 
               useContext}          from 'react';
import {Container, Card, Row, Col}  from 'react-bootstrap';
import api                          from './AxiosConfig';
import SubGoalRow                   from './SubGoalRow';
import RAGStatus                    from './RAGStatus';
import { BsFillPencilFill,
         BsFillGearFill,
         BsFillCaretDownFill,
         BsFillCaretUpFill}         from "react-icons/bs";
import { useNavigate }              from 'react-router-dom';
import { SelectionContext }         from './SelectionContext';

function MasterGoal( props ) {
  const [goalId,           setGoalId]          = useState();
  const [masterGoal,       setMasterGoal]      = useState();
  const [subGoals,         setSubGoals]        = useState([]);
  const navigate                               = useNavigate();
  const { getExpanded, 
          toggleExpanded,
          initExpanded       }                 = useContext(SelectionContext);
         
  useEffect(() => {
    if (props && props.goalId) {
        setGoalId(props.goalId);
    }  
  }, [props]);

  useEffect(() => {
       async function getMasterGoal() {
            try {
                if (goalId) {
                    const response = await api.get(`/site/goals/${encodeURIComponent(goalId)}`, {withCredentials: true });
                    setMasterGoal(response.data);
                    initExpanded(response.data.id, response.data.mg_open_state);
                }
            } catch (error) {
                console.log("getMasterGoal: " + error);
            }
        }
        getMasterGoal();
 }, [goalId, initExpanded]);

 useEffect(() => {
       async function getSubGoals() {
            try {
                if (masterGoal && goalId) {
                    const response = await api.get(`/site/sub-goals/${encodeURIComponent(goalId)}`, {withCredentials: true });
                    setSubGoals(response.data);
                }
            } catch (error) {
                console.log("getSubGoals: " + error);
            }
        }
        getSubGoals();
 }, [masterGoal, goalId]);
           
 const handleUpdate = (id) => {
        navigate('/update-goal', { state: { id } });     
 };
  
 const handleSettings = (id) => {
        navigate('/edit-goal', { state: { id } });     
 };

 const handleExpanded = () => {
     if ( goalId ) {
         toggleExpanded( goalId );
     }
 }
         
 return (
    <Container>
      <Row className="justify-content-md-center">
        <Col>
          { goalId && masterGoal ? (
            <Card className={'mb-1 mt-2 card-goal-type-' + masterGoal.goal_type}>
            <Card.Header className="card-goal-header">
              <div class="content-container">
                <div class="left-content d-flex align-items-center">
                  <span class="me-2"><RAGStatus color="w" status={masterGoal.rag_status} /></span>
                  <span>{masterGoal.goal_title}</span>
                </div>
  
                <div class="right-content">
                   <BsFillGearFill onClick={() => handleSettings(goalId)} />
                   <BsFillPencilFill onClick={() => handleUpdate(goalId)}/>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <Card.Text class="me-2">{masterGoal.goal_description}</Card.Text>
              <div className={'content-container card-SubHeader black-border'}>
              <div class="left-content d-flex align-items-center">
                  <div>Sub-goals:</div>
              </div>
              <div class="right-content">
                  { goalId && getExpanded(goalId) ? (<BsFillCaretUpFill onClick={handleExpanded} />) : (
                   <BsFillCaretDownFill onClick={handleExpanded}/> ) }
              </div>
              </div>
              { goalId && getExpanded(goalId) && subGoals.map((sg, index) => (
                  sg.is_archived === 0 && <SubGoalRow key={index} goalId={sg.id} />
               ))}
             </Card.Body>
             </Card> ) : ( <p>Loading...</p> ) }
        </Col>
      </Row>
    </Container>
  );
}

export default MasterGoal;
